export const sidebarConstants = {
  TOGGLE: 'TOGGLE',
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
};
